import { PrimaryButton, SecondaryButton } from '../../../../components/Button';
import { DerivedColumnEditActionsWrapperDiv } from './DerivedColumnEditUI';
import React, { useCallback, useState } from 'react';
import WarningModal from '../../../../components/ConfirmationModal/WarningModal';

export interface IProps {
  canConfirm: boolean;
  onPreviewClick: () => void;
  onConfirmClick: () => void;
  onCancel?: () => void;
  isNewDraft: boolean;
}

const DerivedColumnEditActionButtons = ({
  canConfirm,
  onConfirmClick,
  onPreviewClick,
  onCancel,
  isNewDraft,
}: IProps) => {
  const [warningConfirmed, setWarningConfirmed] = useState(isNewDraft);
  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const handleConfirmClick = useCallback(() => {
    if (warningConfirmed) {
      onConfirmClick();
    } else {
      setWarningModalOpen(true);
    }
  }, [onConfirmClick, warningConfirmed]);

  const handleWarningConfirm = useCallback(() => {
    setWarningConfirmed(true);
    setWarningModalOpen(false);
    onConfirmClick();
  }, [onConfirmClick]);

  const handleWarningCancel = useCallback(() => {
    setWarningConfirmed(false);
    setWarningModalOpen(false);
  }, []);

  return (
    <>
      <DerivedColumnEditActionsWrapperDiv>
        {!!onCancel && (
          <SecondaryButton
            onClick={onCancel}
            isOutlined={true}
            trackContext="data modeler"
            trackAction="derived column - cancel"
          >
            Cancel
          </SecondaryButton>
        )}
        <SecondaryButton
          disabled={!canConfirm}
          onClick={onPreviewClick}
          isOutlined={true}
          trackContext="data modeler"
          trackAction="derived column - preview"
        >
          Preview
        </SecondaryButton>
        <PrimaryButton
          disabled={!canConfirm}
          onClick={handleConfirmClick}
          trackContext="data modeler"
          trackAction="derived column - confirm"
        >
          Confirm
        </PrimaryButton>
      </DerivedColumnEditActionsWrapperDiv>
      {warningModalOpen && (
        <WarningModal
          onCancel={handleWarningCancel}
          onConfirm={handleWarningConfirm}
          trackContext="data modeler"
          trackConfirmAction="edit derived column - confirm"
          trackCancelAction="edit derived column - cancel"
        >
          Editing an already published column definition can alter the results
          from existing reports when re-executed. Are you sure you want to
          continue?
        </WarningModal>
      )}
    </>
  );
};

export default DerivedColumnEditActionButtons;
